export default function() {
  let designAdvice = document.querySelector('.js-dpa-form')

  if(designAdvice){

    let designAdviceClicks = document.querySelectorAll('.form-click')

    function designAdviceForm(e){
      let saveClick = e.target.getAttribute('data-form-click')
      let select = designAdvice.querySelector('select[name=secretClick]')
      select.value = saveClick;
    }

    designAdviceClicks.forEach((designAdviceClick) => {
      designAdviceClick.addEventListener('click', designAdviceForm)
    })


  }
}
